interface JSONAPIError {
  message: string;
  code: Maybe<string>;
}

interface APIError {
  kind: 'APIError';
  message: string;
  code: Maybe<string>;
}

function fromJSON(jsonAPIError: JSONAPIError): APIError {
  return {
    kind: 'APIError',
    message: jsonAPIError.message,
    code: jsonAPIError.code,
  };
}

export default APIError;
export { JSONAPIError, APIError, fromJSON };
